<app-modal-panel #modalPanel [headerTitle]="title" [buttonTitle]="buttonTitle" [allowSubmit]="storyboardForm.form.valid" (submit)="onSave()">
    <div class="content">
      <div class="modal-body pt-0 pb-0">
        <div class="modal-content border-0">
          <form #storyboardForm="ngForm" novalidate (ngSubmit)="onSave()">
            <div class="row">
              <div class="col-sm-12 mb-1">
                <span class="title">Storyboard Name*</span>	
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <input inputFocus name="name" class="form-control border-0" type="text" 
                  [(ngModel)]="storyboard.displayName" [attr.placeholder]="'Storyboard Name'" required>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 mt-3 mb-1">
                <span class="title">Publication Date*</span>
              </div>
            </div>
            <div class="row">
              <div class=	"col-sm-7">
                <app-date-picker name="publicationDate" [(ngModel)]="storyboard.createdTime" [allowNow]="true" required></app-date-picker>
              </div>
            </div>
    
          </form>
        </div>
      </div>
    </div>
  </app-modal-panel> 
  